import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import OrderApprovalDetailsState from "@store/Framework/Store/Store/Pages/OrderApprovalDetails/OrderApprovalDetailsState";
import { Draft } from "immer";

const initialState: OrderApprovalDetailsState = {
    isDeclining: false,
};

const actions = {
    "Store/Pages/OrderApprovalDetails/BeginDeclineOrder": (draft: Draft<OrderApprovalDetailsState>) => {
        draft.isDeclining = true;
    },
    "Store/Pages/OrderApprovalDetails/CompleteDeclineOrder": (draft: Draft<OrderApprovalDetailsState>) => {
        draft.isDeclining = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type OrderApprovalDetailsActions = Parameters<typeof reducer>[1];
export default reducer;
